import { useCallback, useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useTitle } from 'react-use';
import type { Dispatch } from 'redux';
import cn from 'classnames';

import { getUserRoleIsAdmin } from 'AuthPackage/MainModule/selectors/authSelectors';
import { Layout } from 'CorePackage/MainModule/components/Layout';
import { SelectInput, ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { INews } from 'APIPackage/NewsModule/interfaces/INews';

import { NewsItem } from './NewsItem';
import styles from './NewsPage.module.scss';
import { rolesDict } from '../constants/rolesDict';
import { getNewsData, getNewsFilterOption } from '../selectors/newsSelectors';
import { newsGetData, newsInitPage, newsSetFilterOption } from '../actions/newsActions';

const filterOptions: ISelectOption[] = Object.values(rolesDict);

interface INewsPageProps {
  isAdmin: boolean;
  news: INews[];
  filterOption: string;
}

const NewsPageWithoutStore = ({ isAdmin, news, filterOption }: INewsPageProps) => {
  useTitle('Новости');

  const filterOptionValue = useMemo(() => filterOptions.find(item => item.value === filterOption), [filterOption]);

  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    dispatch(newsInitPage());
  }, [dispatch]);

  const onOptionChange = useCallback(
    (option: ISelectOption) => {
      dispatch(newsSetFilterOption(option.value));
      dispatch(newsGetData());
    },
    [dispatch],
  );

  return (
    <Layout withFooter>
      <div className={styles.NewsPage}>
        <div className={styles.Title}>
          Новости
          {isAdmin && (
            <SelectInput
              className={cn('shared-field-small', styles.Filter)}
              options={filterOptions}
              value={filterOptionValue}
              placeholder="Фильтр по роли"
              onChange={onOptionChange}
              isClearable={false}
            />
          )}
        </div>
        <ul className={styles.NewsList}>
          {news.map(newsItemData => (
            <li className={styles.NewsItem} key={newsItemData.id}>
              <NewsItem {...newsItemData} />
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state: IRootState) => ({
  isAdmin: getUserRoleIsAdmin(state),
  news: getNewsData(state),
  filterOption: getNewsFilterOption(state),
});

export const NewsPage = connect(mapStateToProps)(NewsPageWithoutStore);
